/* src/app/rating/rating.component.scss */
/*# sourceMappingURL=rating.component.css.map */
